import { Schema as S } from "effect";
export const Schema = S.Number.pipe(S.brand("@open-revenue/schema/products/RecurringIntervalCount"), S.annotations({
    title: "Recurring Interval Count",
    description: "The count of the recurring interval. Ex: 1 month = 1, 3 months = 3",
    examples: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10
    ]
}));
export const make = (value)=>S.decodeUnknown(Schema)(value);
export const makeUnsafe = (value)=>value;
